// extracted by mini-css-extract-plugin
export default {"page":"ToolsPage_page__szRT5","center":"ToolsPage_center__BFzmP"};